export default "__VITE_ASSET__C3i8rNjD__"